(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-image-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aa-image-showcase')) {
    customElements.define(
      'aa-image-showcase',
      class AAImageShowcase extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.viewport = this.querySelector('.aa-image-showcase__viewport');
          this.mobileMedia = window.matchMedia('(max-width: 749px)');
          this.originalCards = Array.from(
            this.querySelectorAll('.aa-image-showcase__card:not(.is-clone)')
          ).sort((firstCard, secondCard) => {
            return Number(firstCard.dataset.cardIndex) - Number(secondCard.dataset.cardIndex);
          });

          this.setupResponsiveColumns();
          this.setupHoverPause();
          this.setupVisibilityObserver();
        }

        disconnectedCallback() {
          if (this.visibilityObserver) this.visibilityObserver.disconnect();

          if (this.handleBreakpointChange) {
            this.mobileMedia.removeEventListener('change', this.handleBreakpointChange);
          }

          if (this.handlePointerEnter) {
            this.removeEventListener('pointerenter', this.handlePointerEnter);
            this.removeEventListener('pointerleave', this.handlePointerLeave);
            this.removeEventListener('focusin', this.handleFocusIn);
            this.removeEventListener('focusout', this.handleFocusOut);
          }
        }

        setupResponsiveColumns() {
          if (!this.viewport || this.originalCards.length === 0) {
            this.tracks = [];
            return;
          }

          this.handleBreakpointChange = () => this.buildColumnLayout();
          this.mobileMedia.addEventListener('change', this.handleBreakpointChange);
          this.buildColumnLayout();
        }

        buildColumnLayout() {
          const configuredColumns = Number.parseInt(
            this.mobileMedia.matches ? this.dataset.mobileColumns : this.dataset.desktopColumns,
            10
          );
          const columnCount = Math.max(
            1,
            Math.min(configuredColumns || 1, this.originalCards.length)
          );
          const fragment = document.createDocumentFragment();
          const tracks = [];

          this.viewport.replaceChildren();

          for (let columnIndex = 0; columnIndex < columnCount; columnIndex += 1) {
            const column = document.createElement('div');
            const track = document.createElement('div');

            column.className = 'aa-image-showcase__column';
            track.className = 'aa-image-showcase__track';
            track.dataset.direction = columnIndex % 2 === 0 ? 'up' : 'down';
            column.appendChild(track);
            fragment.appendChild(column);
            tracks.push(track);
          }

          this.originalCards.forEach((card, cardIndex) => {
            tracks[cardIndex % columnCount].appendChild(card);
          });

          this.viewport.appendChild(fragment);
          this.style.setProperty('--aa-showcase-columns', columnCount);
          this.tracks = tracks;
          this.duplicateTrackItems();
        }

        duplicateTrackItems() {
          this.tracks.forEach((track) => {
            const originalCards = Array.from(track.children).filter(
              (card) => !card.classList.contains('is-clone')
            );

            originalCards.forEach((card) => {
              const clone = card.cloneNode(true);

              clone.classList.add('is-clone');
              clone.setAttribute('aria-hidden', 'true');
              clone.setAttribute('inert', '');
              clone.removeAttribute('data-shopify-editor-block');
              clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
                element.removeAttribute('data-shopify-editor-block');
              });
              clone.querySelectorAll('a, button, input, select, textarea, video').forEach((element) => {
                element.setAttribute('tabindex', '-1');
              });

              track.appendChild(clone);
            });
          });
        }

        setupHoverPause() {
          if (this.dataset.pauseOnHover !== 'true') return;

          this.handlePointerEnter = () => this.classList.add('is-hover-paused');
          this.handlePointerLeave = () => this.classList.remove('is-hover-paused');
          this.handleFocusIn = () => this.classList.add('is-hover-paused');
          this.handleFocusOut = (event) => {
            if (!this.contains(event.relatedTarget)) this.classList.remove('is-hover-paused');
          };

          this.addEventListener('pointerenter', this.handlePointerEnter);
          this.addEventListener('pointerleave', this.handlePointerLeave);
          this.addEventListener('focusin', this.handleFocusIn);
          this.addEventListener('focusout', this.handleFocusOut);
        }

        setupVisibilityObserver() {
          if (this.prefersReducedMotion || !('IntersectionObserver' in window)) {
            this.classList.add('is-in-view');
            return;
          }

          this.visibilityObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.classList.toggle('is-in-view', entry.isIntersecting);
              });
            },
            { threshold: 0.1 }
          );

          this.visibilityObserver.observe(this);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
